import React from 'react';
import {Table} from 'semantic-ui-react';

const Severity = ({severity}) => <Table.Cell>{severity}</Table.Cell>;

export default Severity;
